import React from "react";
import {Helmet} from "react-helmet";

import "../../assets/css/library/splide.min.css";
import "../../assets/css/library/bootstrap.min.css";
import "../../assets/css/utility/home_page_header.css";
import "../../assets/css/home_page.css";

import Header from './components/Header'
import Banner from './components/Banner';
import HowItWork from './components/HowItWork'
import WhyUs from './components/WhyUs';
import OurState from './components/OurState';
import Trusted_By from './components/Trusted_By';
import Users_Feedback from './components/Users_Feedback';
import Featured_on from './components/Featured_on';
import FounderMessage from './components/FounderMessage';
import OurLocation from './components/OurLocation';
import Faq from './components/Faq'
import Footer from "../../components/Footer";


const Home = () => {
  return (
    <>
      <Helmet>
        <style>
            {`
              body {
                  background: #fff !important;
              }

              footer::before {
                  background: linear-gradient(180deg, #ffffff 23.96%, rgba(255, 255, 255, 0.88) 100%) !important;
              }
          `}
        </style>
      </Helmet>
    
      <div className="welcome-message">
        <p>Welcome Message</p>
      </div>

      <Header/>

      <Banner/>

      <HowItWork/>

      <WhyUs/>

      <OurState/>

      <Trusted_By/>

      <Users_Feedback/>

      <Featured_on/>

      <FounderMessage/>

      <Faq/>
      <OurLocation />
      <Footer />
    </>
  );
};

export default Home;
